import { Select } from '@any-ui-react/core';
import classNames from 'classnames';

import { HalfYear } from '@/common/graphql';

import { YearFilter } from './YearFilter';

export const HALF_OPTIONS = [
  { value: HalfYear.H1, label: 'H1 (Jan - Jun)' },
  { value: HalfYear.H2, label: 'H2 (Jul - Dec)' },
];

interface YearHalfRangeSelectProps {
  className?: string;
  disabled?: boolean;
  fromYear: string;
  fromHalf: HalfYear;
  toYear: string;
  toHalf: HalfYear;
  onChangeFromYear: (value: string) => void;
  onChangeFromHalf: (value: HalfYear) => void;
  onChangeToYear: (value: string) => void;
  onChangeToHalf: (value: HalfYear) => void;
}

export const YearHalfRangeSelect = ({
  className,
  disabled,
  fromYear,
  fromHalf,
  toYear,
  toHalf,
  onChangeFromYear,
  onChangeFromHalf,
  onChangeToYear,
  onChangeToHalf,
}: YearHalfRangeSelectProps) => (
  <div className={classNames('flex flex-wrap items-center gap-2', className)}>
    <YearFilter disabled={disabled} placeholder="From Year" value={fromYear} onChange={onChangeFromYear} />
    <Select
      className="w-36"
      data={HALF_OPTIONS}
      disabled={disabled}
      placeholder="Half"
      value={fromHalf}
      onChange={v => onChangeFromHalf((v as HalfYear) ?? HalfYear.H1)}
    />
    <span aria-hidden="true">–</span>
    <YearFilter disabled={disabled} placeholder="To Year" value={toYear} onChange={onChangeToYear} />
    <Select
      className="w-36"
      data={HALF_OPTIONS}
      disabled={disabled}
      placeholder="Half"
      value={toHalf}
      onChange={v => onChangeToHalf((v as HalfYear) ?? HalfYear.H1)}
    />
  </div>
);
